import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders,HttpParams  } from '@angular/common/http';
import {Globals} from '../globals'
import { Observable } from 'rxjs';
import {
  GetDesignationRightsResponse,
  SaveDesignationRightRequest,
  SaveDesignationRightsResponse,
} from '../Core/DesignationRights/designationrights.model';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'my-auth-token'
  })
};

@Injectable()
export class AuthService {


    apiUrl = Globals.apiUrl;
    constructor(private http: HttpClient) {}
    // UserLogin(userName, token, tempTokenTime, IsEncrypted){
    //    var form = {UserName:userName, jwtToken:token, jwtTokenExpiredTime:tempTokenTime, isEncrypted:IsEncrypted}
    //   return  this.http.post<any>(this.apiUrl + 'AccountService/UserLogin', form);
    // }

    UserLogin(userName, Password, token, tempTokenTime, IsEncrypted,recaptchaToken){
      var form = {UserName:userName, Password:Password, jwtToken:token, jwtTokenExpiredTime:tempTokenTime, isEncrypted:IsEncrypted,RecaptchaToken:recaptchaToken}
     return  this.http.post<any>(this.apiUrl + 'AccountService/UserLogin', form);
   }
   verifyOtp(userName, OTPCode,SessionId, token, tempTokenTime, IsEncrypted){
      var form = {UserName:userName,OTPCode:OTPCode, SessionId:SessionId, jwtToken:token, jwtTokenExpiredTime:tempTokenTime, isEncrypted:IsEncrypted}
     return  this.http.post<any>(this.apiUrl + 'AccountService/VerifyOTP', form);
   }
   getRecaptchaEnabled() {
    return this.http.get<boolean>(this.apiUrl +'AccountService/recaptcha');
  }
     GetOrgSetting() {
    return this.http.get<any>(this.apiUrl +'AccountService/orgsetting');
  }
    GetEncryptedDetailForForum(){
     return  this.http.post<any>(this.apiUrl + 'AccountService/GetEncryptedDetailForForum',"");
   }

    GetPasswordLoggedInUser()
    {
      return  this.http.post<any>(this.apiUrl + 'AccountService/GetPasswordLoggedInUser', "");
    }
    tokenKey="token";
    // this.authService.UserLogin("priyank80@me.com").subscribe(list =>
    //     {
    //       console.log(list);
    //       sessionStorage.setItem('token',list.token)
    //     }
    //   );
    GetMenus(ActiveUserID,designationId,designationName,CurruntPage){
      var form = {activeUserID:ActiveUserID,DesignationId:designationId,DesignationName:designationName,curruntPage:CurruntPage}
     return  this.http.post<any>(this.apiUrl + 'AccountService/GetMenus', form);
   }

    GetPageRights(menuName)
    {
      var obj = {str:menuName}
      //return "00000";
      return  this.http.post<any>(this.apiUrl + 'AccountService/GetMenusRights', obj);
    }

    ValidateConfirmationUser(credential) {
      return  this.http.post<any>(this.apiUrl + 'AccountService/ValidateConfirmationUser', credential);
    }

    UpdateContactDetails(value) {
      return this.http.post<any>(
        this.apiUrl + 'AccountService/UpdateContactDetails',
        value,
        httpOptions
      );
    }

    GetCurrentUserDivision() {
      return  this.http.post<any>(this.apiUrl + 'UserService/GetContactDivisionsByContactID', {Id:this.GetUserId()});
    }


    GetDashBoardMVC(obj) {
      return this.http.post<any>(
        this.apiUrl + 'DeskboardService/GetDashBoardMVC',
        obj,
        httpOptions
      );
    }

    GetTasksMonthly() {
      return this.http.post<any>(
        this.apiUrl + 'DeskboardService/GetTasksMonthly',
        '',
        httpOptions
      );
    }

    GetRepairsMonthly() {
      return this.http.post<any>(
        this.apiUrl + 'DeskboardService/GetRepairsMonthly',
        '',
        httpOptions
      );
    }

    GetDMRepairsMonthly() {
      return this.http.post<any>(
        this.apiUrl + 'DeskboardService/GetDMRepairsMonthly',
        '',
        httpOptions
      );
    }

    CheckNotificationForTask() {
      return this.http.post<any>(
        this.apiUrl + 'DeskboardService/CheckNotificationForTask',
        '',
        httpOptions
      );
    }

    InsertNoteForTaskNotification() {
      return this.http.post<any>(
        this.apiUrl + 'DeskboardService/InsertNoteForTaskNotification',
        '',
        httpOptions
      );
    }

    GetScheduleDetailsSearchByUsers(obj) {
      return this.http.post<any>(
        this.apiUrl + 'DeskboardService/GetScheduleDetailsSearchByUsers',
        obj,
        httpOptions
      );
    }


    getToken() {
        return sessionStorage.getItem(this.tokenKey);
      }

      setSSOEmail(Email) {

        sessionStorage.setItem("UserEmailEnc",Email);
      }

      GetSSOEmail() {
        if(!this.isAuthenticated)
        {
          return "";
        }
        var token =sessionStorage.getItem("UserEmailEnc");
        if(token != undefined && token !=null )
        {
          return token;
        }
        else
        {
          return "";
        }

      }


      GetUrgentMessages(){

     return  this.http.post<any>(this.apiUrl + 'AccountService/GetUrgentMessages', "");
   }
   GetUrgentTasks(){

    return  this.http.post<any>(this.apiUrl + 'AccountService/GetUrgentTasks', "");
  }

      setToken(token) {
        sessionStorage.setItem(this.tokenKey, JSON.stringify(token));
      }

      getAccessToken() {
        var token =sessionStorage.getItem(this.tokenKey);
        if(token != undefined && token !=null)
        {
        return JSON.parse(sessionStorage.getItem(this.tokenKey))['access_token'];
        }
        else
        {
          return undefined;
        }
      }

      getAccessTokenExpiryDate() {
        var token =sessionStorage.getItem(this.tokenKey);
        if(token != undefined && token !=null)
        {
        return JSON.parse(sessionStorage.getItem(this.tokenKey))['exp'];
        }
        else
        {
          return null;
        }
      }

      GetUserId()
      {

        var token = this.getAccessToken();
        if(token != null || token != undefined)
        {
          return  token.ContactId;
        }
      }

      GetDesignationName()
      {
        let token = this.getAccessToken();
        if(token != null || token != undefined)
        {
          return  token.DesignationName;
        }
      }

      GetIsAdminPermission()
      {
        let token = this.getAccessToken();
        if(token != null || token != undefined)
        {
          return  token.IsAdminPermission;
        }
      }

      //Email
      GetUserEmail()
      {

        var token = this.getAccessToken();
        if(token != null || token != undefined)
        {
          return token.Email;
        }
      }
      //FullName
      GetUserName()
      {

        var token = this.getAccessToken();
        if(token != null || token != undefined)
        {
          return token.FullName.replace("<br/>", " ");

        }
      }
      GetUserFLName()
      {

        var token = this.getAccessToken();
        if(token != null || token != undefined)
        {
          return token.FirstName + ' ' + token.LastName;

        }
      }
      GetUserFirstName()
      {
        var token = this.getAccessToken();
        if(token != null || token != undefined)
        {
          return token.FirstName;
        }
      }

      isAuthenticated() {

        let token = sessionStorage.getItem(this.tokenKey);

        if (token) {
          var token1 = JSON.parse(token);

          if( new Date(token1.exp) < new Date())
          {
            this.removeToken();
            return false;
          }
          else
          {
            return true;
          }
        }
        else {
          return false;
        }
      }

      // refreshToken() {
        // var token = JSON.parse(sessionStorage.getItem(this.tokenKey));
        // token.exp = new Date((new Date().getDate() +1));
        // console.log(token.exp);
        //  this.setToken(token);
      // }

      removeToken() {
        sessionStorage.removeItem(this.tokenKey);
      }

      GetCurrentDateTimeFromServer(){
        return  this.http.post<any>(this.apiUrl + 'CommonService/GetCurrentDateTimeFromServer', "");
      }
GetContactDetailsByEmail(value) {
      return this.http.post<any>(
        this.apiUrl + 'AccountService/GetContactDetailByEmail',
        value
      );
    }
    FillCountry() {
      return this.http.post<any>(
        this.apiUrl + 'AccountService/FillCountry',
        ''
      );
    }

    FillState(value) {
      return this.http.post<any>(
        this.apiUrl + 'AccountService/FillState',
        value
      );
    }

    GetDesignationRights(designationId: number): Observable<GetDesignationRightsResponse> {
      return this.http.post<GetDesignationRightsResponse>(`${this.apiUrl}/AccountService/GetDesignationRights`, { Id: designationId },httpOptions);
    }

    SaveDesignationRights(rows: SaveDesignationRightRequest[]): Observable<SaveDesignationRightsResponse> {
      return this.http.post<SaveDesignationRightsResponse>(`${this.apiUrl}/AccountService/SaveDesignationRights`, rows,httpOptions);
    }

    SendOTP(value)
    {
      
      //return "00000";
      return  this.http.post<any>(this.apiUrl + 'AccountService/SendOTP', value);
    }
    VerifyOTPCompleteRegistration(userName, OTPCode,SessionId, token, tempTokenTime, IsEncrypted){
      var form = {UserName:userName,OTPCode:OTPCode, SessionId:SessionId, jwtToken:token, jwtTokenExpiredTime:tempTokenTime, isEncrypted:IsEncrypted}
     return  this.http.post<any>(this.apiUrl + 'AccountService/VerifyOTPCompleteRegistration', form);
   }

   requestPasswordReset(email: string) {
  // Adjust URL as per your backend routes
  return this.http.post(`${this.apiUrl}AccountService/forgot-password`, { email });
}

resetPassword(token: string, newPasswordOrPin: string) {
  return this.http.post(`${this.apiUrl}AccountService/reset-password`, {
    token,
    newPasswordOrPin
  });
}

ResetPasswordSendOTP(value)
    {
      
      //return "00000";
      return  this.http.post<any>(this.apiUrl + 'AccountService/ResetPasswordSendOTP', value);
    }
    ResetPasswordVerifyOTP(userName, OTPCode,SessionId, token, tempTokenTime, IsEncrypted){
      var form = {UserName:userName,OTPCode:OTPCode, SessionId:SessionId, jwtToken:token, jwtTokenExpiredTime:tempTokenTime, isEncrypted:IsEncrypted}
     return  this.http.post<any>(this.apiUrl + 'AccountService/ResetPasswordVerifyOTP', form);
   }

}
